/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.10.0",
  "gitBuildTime": "2026-10-06T14:53:48.093Z",
  "gitBuildVersion": "2.10.0",
  "gitCommitId": "a44b3b3",
  "gitCommitIdFull": "a44b3b307742ecebfb875e7e30080aae65c6b2d7",
  "gitCommitTime": "2026-10-06T14:49:36.000Z",
  "version": "2.10.0-2026-10-06T14:49:36.000Z-(a44b3b3)"
};
